import { NotProcessedCandidatesComponent } from "./not-processed-candidates.component";
export const NotProcessedCandidatesModule = angular
    .module('notProcessedCandidates', [])
    .config(['$stateProvider', ($stateProvider) => {
        $stateProvider.state('missioncontrol.notprocessedcandidates', {
            url: '/notprocessedcandidates',
            component: NotProcessedCandidatesComponent.selector,
            data: {
                requireLogin: true
            }
        });
    }
])
    .component(NotProcessedCandidatesComponent.selector, NotProcessedCandidatesComponent.component)
    .name;
//# sourceMappingURL=not-processed-candidates.module.js.map